export default {
  signUpSuccess: 'Succesfully registered! You\'ve been signed in as well.',
  signUpFailure: 'Registration failed. Email may be taken, or passwords don\'t match.',
  signInSuccess: 'Welcome!',
  signInFailure: 'Failed to sign in. Check your email and password and try again.',
  signOutSuccess: 'Come back soon!',
  changePasswordSuccess: 'Password changed successfully!',
  changePasswordFailure: 'Failed to change passwords. Check your old password and try again.',
  pokemonCreateSuccess: 'Succesfully made a pokemon! Check it out!',
  pokemonCreateFailure: 'Could not successfully create a pokemon',
  deletePokemonSuccess: 'Succesfully deleted pokemon',
  deletePokemonFailure: 'Could not delete the pokemon',
  updatePokemonSuccess: 'Successfully updated pokemon',
  updatePokemonFailue: 'Could not update the pokemon'
}



// WEBPACK FOOTER //
// ./src/components/AutoDismissAlert/messages.js